import React, { useEffect, useState } from "react";
import queryString, { parse } from 'query-string';
import history from "../../history";
import sorumluSecimListesi from "../../services/sorumluSecimListesi";
import { Divider, List,Spin } from 'antd';
import * as util from "../Helpers/Util";

const parsed = queryString.parse(history.location.search);


const BasvuruSorumluKullaniciForm = () => {

    const [spining, setSpining] = useState(true);
    const [raportorList, setRaportorList] = useState([]);


    const loadForm = async () => {
        setSpining(true);
        await sorumluSecimListesi(parsed.basvuruId).then(resp => {
            if (resp.data.success) {
                setRaportorList(resp.data.result);
            } else {
                util.errorMessage(resp.data.message);
            }
        }).catch(ex => {
            util.errorMessage(String(ex.message));
        });
        setSpining(false);
    }
    useEffect(() => {
        loadForm();
    }, []);


    return(
        <Spin tip={"Veriler Yükleniyor"} spinning={spining}>        
        <Divider orientation="left">{parsed.basvuruId} No'lu Başvuru Sorumlu Kullanıcılar</Divider>
        <List
            bordered
            dataSource={raportorList}
            renderItem={(item) => (    
                <>        
                    <List.Item style={{width:'100%', textAlign:'left'}} >    
                        <p style={{width:'35%', textAlign:'left'}}>    {item.editorAdi} </p>
                        <p style={{width:'5%', textAlign:'left'}}> : </p>
                        <p style={{width:'60%', textAlign:'left'}}>    {util.isNullOrEmptyOrUndefined(item.sorumluKullaniciAdi) ? '-' : item.sorumluKullaniciAdi} </p>
                    </List.Item>
                </>
            
            )}
        />        
        </Spin>
       
    );

}

export default BasvuruSorumluKullaniciForm;